import logger from './utils/logger.js';
import { getPagename, getPageCategory, getPageType, getVirtualPath } from './utils/dataRouteFormat.js';
import { isAuthenticated, getToken } from './utils/auth.js';

// Function: Pushes "Page view" event to dataLayer
// Specs:
// - This function is called whenever a page is loaded
const pageView = (route, catalogId, asPath, overrideDataLayerRoutes, category, virtualPath) => {
    const eventName = virtualPath ? 'virtual_pageview' : 'page_view';
    // Override route logic
    let overrideObj;
    overrideDataLayerRoutes.forEach(routeObj => {
        if (asPath.includes(routeObj.name)) {
            overrideObj = routeObj;
        }
    });
    // page data
    const pagename = getPagename((virtualPath === null || virtualPath === void 0 ? void 0 : virtualPath.name) || route, catalogId, asPath, overrideObj);
    const pageCategory = (overrideObj === null || overrideObj === void 0 ? void 0 : overrideObj.pageCategory) || getPageCategory((virtualPath === null || virtualPath === void 0 ? void 0 : virtualPath.name) || route);
    const pageType = (overrideObj === null || overrideObj === void 0 ? void 0 : overrideObj.pageType) || getPageType((virtualPath === null || virtualPath === void 0 ? void 0 : virtualPath.name) || route, asPath);
    let pageVirtualPath = (overrideObj === null || overrideObj === void 0 ? void 0 : overrideObj.pageVirtualPath) || getVirtualPath(route, asPath);
    if (virtualPath) {
        const addSlash = pageVirtualPath.slice(-1) === '/' ? '' : '/';
        pageVirtualPath += `${addSlash}${virtualPath.pathName}`;
    }
    // user data
    const userIsLogged = isAuthenticated() ? 1 : 0;
    const userId = getToken();
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ page_data: null });
    window.dataLayer.push({
        event: eventName,
        page_data: {
            page_name: pagename,
            page_category: pageCategory,
            page_type: pageType,
            ...(category ? { page_sub_category_level_1: category } : {}),
            page_virtual_path: pageVirtualPath,
        },
        user_data: {
            user_is_logged: userIsLogged,
            ...(userId ? { user_id: userId } : {}),
        },
    });
    logger('Page view event sent', { category: 'analytics' });
};

export { pageView as p };
//# sourceMappingURL=pageView-EPLyidHy.js.map
